module.exports = __webpack_public_path__ + "media/notices/Repeción de SRC-2-ae9472f0.jpg";